<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('monitoringCenter.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('zi-yuan-zhong-xin') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('chong-dian-qiang-guan-li') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card">
            <el-row>
              <search
              :searchForm="searchForm"
              :stationsForSelect="stationsForSelect"
              :operatorForSelect="operatorForSelect"
              :searchLoading="searchLoading"
              :stateData="enumData.stateData"
              @submitSearchForm="submitSearchForm"
              @operatorSelect="operatorSelect"
              ref="searchForm"
              ></search>
              <el-form>
                <el-col :span="1.5" class="diy-class">
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="gunAdd" icon="el-icon-plus" class="el-btn"
                               v-if="checkPermission(['bee:res:gun:saveOrUpdateGun'])">{{ $t('xin-zeng-chong-dian-qiang') }}
                    </el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="2" class="diy-class" style="margin-left: 10px;">
                  <el-form-item>
                    <el-button size="mini" type="primary"  @click="exportCode('gunCode')" :loading="exportLoading" icon="el-icon-download" class="el-btn"  v-if="checkPermission(['bee:res:gun:exportCode'])">{{ $t('qiang-hao-er-wei-ma-dao-chu') }}</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="2.5" class="diy-class" style="margin-left: 10px;">
                  <el-form-item>
                    <el-button size="mini" type="primary"  @click="exportCode('hlht')" :loading="exportLoading" icon="el-icon-download" class="el-btn"  v-if="checkPermission(['bee:res:gun:exportCode'])">{{ $t('hu-lian-hu-tong-er-wei-ma-dao-chu') }}</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="2" class="diy-class" style="margin-left: 10px;">
                  <el-popover v-if="checkPermission('bee:res:gun:exportCode')"  placement="top" width="200">
                    <el-form class="exportQRCode" :model="exportQRCodeForm" ref="exportQRCodeForm" size="mini">
                      <el-col>
                        <el-form-item prop="qrCode">
                          <el-input type="textarea" :placeholder="$t('url-qian-zhui-li-ru-httpswwwwbaiducom')" v-model="exportQRCodeForm.url" clearable></el-input>
                        </el-form-item>
                      </el-col>
                    </el-form>
                    <div style="text-align: center">
                      <el-button type="primary" size="mini" @click="exportQRCodeSubmit('self')" :loading="exportLoading">{{ $t('xia-zai') }}</el-button>
                    </div>
                    <el-button slot="reference" type="primary"  size="mini" icon="el-icon-download" class="el-btn" >{{ $t('zi-ying-er-wei-ma-dao-chu') }}</el-button>
                  </el-popover>
                </el-col>
              </el-form>
            </el-row>
            <!--列表数据-->
            <el-tab-pane :label="$t('chong-dian-qiang-guan-li-0')" name="gunList">
              <!--      列表组件        -->
              <list
              :gunDataTable="gunDataTable"
              :listLoading="listLoading"
              @gunDetail="gunDetail"
              @gunEdit="gunEdit"
              @gunDelete="gunDelete"
              ></list>
              <!-- 分页组件 -->
              <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <!-- 编辑组件 -->
      <add
      :editForm="editForm"
      :editFormVisible="editFormVisible"
      :showFormFlag="showFormFlag"
      :operatorForSelect="operatorForSelect"
      :stationsForSelect="stationsForSelect"
      :pilesForSelect="pilesForSelect"
      :editSubmitLoading="editSubmitLoading"
      :lockList="lockList"
      @closeEditForm="closeEditForm"
      @searchLockListByAddress="searchLockListByAddress"
      @editSubmit="editSubmit"
      @operatorSelect="operatorSelect"
      @stationSelect="stationSelect"
      @pileSelect="pileSelect"
      @startGunNumCheck="startGunNumCheck"
      @endGunNumCheck="endGunNumCheck"
      ></add>
      <!--详情组件-->
      <detail
        :detailFormVisible="detailFormVisible"
        :detailForm="detailForm"
        @closeDetailForm="closeDetailForm"
      ></detail>
    </el-main>
  </el-container>
</template>

<script>
  import Pagination from '../../../components/Pagination'
  import gunApi from '../../resourceCenter/api/gunApi'
  import commonApi from '../../resourceCenter/api/commonApi'
  import pileApi from '../../resourceCenter/api/pileApi'
  import search from "./charginggunManager/search"
  import list from "./charginggunManager/list"
  import add from "./charginggunManager/add"
  import detail from "./charginggunManager/detail"

  export default {
    name: 'charginggunManager',
    data() {
      return {
        lockList: [],
        exportLoading: false,
        enumData: [{
          stateData: ''
        }],
        exportQRCodeForm: {},
        stationsForSelect: '',
        operatorForSelect: [],
        pilesForSelect: '',
        activeName: 'gunList',
        showFilters: true,
        listLoading: false,
        gunDataTable: [{}],
        // 多选集合
        gunDataSelection: [],
        // 查询
        searchLoading: false,
        searchFormVisible: false,
        searchForm: {// 未初始化不传递参数，影响后台接查询
        },
        // 编辑
        editFormVisible: false,
        editSubmitLoading: false,
        editForm: {},
        // 详情
        detailFormVisible: false,
        detailForm: {},
        viewName: 'detailForm',
        formLabelWidth: '100px',

        // 分页参数
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        activeNames: ['basicInformation'],
        showFormFlag:"",
        maxGunNum:""
      }
    },
    methods: {
      async searchLockListByAddress(query) {
        if(query.length > 2 ){
          this.searchLoading = true
          try {
            let pageparam = {
              t: {
                address: query
              },
              currentPage: 1,
                pageSize: 30,
                total: 0
            }
            const {data} = await gunApi.getLockList(pageparam)
            this.lockList = data ? data.list : []
          } finally {
            this.searchLoading = false
          }
        }
      },
      resetSearchForm() {
        this.searchForm = {}
      },
      submitSearchForm() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.searchLoading = true
          this.listLoading = true
          // let param = Object.assign({}, this.stationSearchForm)
          // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
          this.pageparam.t = this.searchForm
          let param = Object.assign({}, this.pageparam)
          gunApi.getGunsPageList(param).then((res) => {
            if (res.code === 0) {
              this.pageparam.total = res.data.total
              this.gunDataTable = res.data.list
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              // this.$message.error(res.message)
            }
            this.searchLoading = false
            this.listLoading = false
          })
        })
      },
      // 多选
      gunDataSelectionChange(val) {
        this.gunDataSelection = val
      },
      gunAdd() {
        // this.$refs["editForm"].clearValidate()
        this.$nextTick(() => {
          this.showFormFlag = "add"
          this.editFormVisible = true
          this.editForm = Object.assign({})
          this.pilesForSelect = ""
          this.stationsForSelect = ""
        })
      },
      gunDetail(index, row) {
        this.detailFormVisible = true
        this.detailForm = Object.assign({}, row)
        gunApi.getRealtimeGunsInfoByGunCode(row.gunCode).then((res) => {
          if (res.code === 0) {
            console.log(res.data)
            this.detailForm.voltage=res.data.DC_V
            this.detailForm.current=res.data.DC_I
            this.detailForm.power=res.data.chargePower
            this.detailForm.quantity=res.data.chargeQuantity
            this.detailForm.soc=res.data.currentSOC
          }
        })
      },
      closeDetailForm(){
        this.detailFormVisible = false
      },
      gunEdit(index, row) {
        this.operatorSelect(row.operatorId)
        // 编辑场站选中时
        this.stationSelect(row.stationId)
        // 编辑设备选中时
        this.pileSelect(row.pileTypeId)
        // this.$refs["editForm"].clearValidate()
        this.showFormFlag = "edit"
        this.editFormVisible = true
        this.editForm = Object.assign({}, row)
        this.editForm.gunConnectionState = this.editForm.gunConnectionState.code
        this.editForm.state = this.editForm.state.code
      },
      editGunNum(val){
        this.editForm.gunCode = this.editForm.pileCode + val.padStart(2,"0")
      },
      editStartGunNum(val){
        this.editForm.startGunCode = this.editForm.pileCode?this.editForm.pileCode + val.padStart(2,"0"):''
      },
      editEndGunNum(val){
        this.editForm.endGunCode = this.editForm.pileCode?this.editForm.pileCode + val.padStart(2,"0"):''
      },
      closeEditForm(){
        this.editFormVisible = false
      },
      editSubmit(editForm) {
        editForm.validate((valid) => {
            if (!valid) {
              return;
            } else {
              this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
                this.editSubmitLoading = true
                if (this.showFormFlag == "add"){
                  let param = JSON.stringify(this.editForm)
                  gunApi.saveOrUpdateGunBatch(param).then((res) => {
                    if (res.code === 0) {
                      this.$message({
                        message: res.message,
                        type: 'success'
                      })
                      this.editFormVisible = false
                      this.submitSearchForm()
                    } else {
                      this.$message.error(res.message)
                    }
                  })
                  this.editSubmitLoading = false
                }else {
                  let param = JSON.stringify(this.editForm)
                  gunApi.saveOrUpdateGunEdit(param).then((res) => {
                    if (res.code === 0) {
                      this.$message({
                        message: res.message,
                        type: 'success'
                      })
                      this.editFormVisible = false
                      this.submitSearchForm()
                    } else {
                      this.$message.error(res.message)
                    }
                  })
                  this.editSubmitLoading = false
                }
              })
            }
        })
      },
      clearEditForm(){
        this.$refs.editForm.clearValidate()
      },
      gunDelete(index, row) {
        if ([-1,0].indexOf(row.stateCode)<0){
          this.$message.error(this.$t('zhi-neng-shan-chu-kong-xian-he-li-xian-zhuang-tai-de-chong-dian-qiang'))
          return
        }
        this.$confirm(this.$t('que-ding-yao-shan-chu') + (row.gunName==null?this.$t('wei-ming-ming-qiang'):row.gunName) + this.$t('ma-0'), this.$t('alaramMonitor.message5'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        })
          .then(() => {
            gunApi.deleteGun(row.id).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.submitSearchForm()
              } else {
                this.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('alaramMonitor.message8')
            })
          })
      },
      changePage() {
        this.submitSearchForm()
      },
      // 加载下拉框
      loadSelectItem() {
        gunApi.getGunEnum().then((res) => {
          this.enumData.stateData = JSON.parse(res.stateData)
        })
      },
      loadForSelect() {
        // 站下拉框
        let operatorId = this.$store.getters.operatorIds
        commonApi.stationsForSelectByOperatorId(operatorId).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data
          }
        })
        // 运营商下拉框
        commonApi.getOperatorsTree().then((res) => {
          if (res.code === 0) {
            this.operatorForSelect = res.data
          }
        })
      },
      operatorSelect(val) {
        commonApi.stationsForSelectByOperatorId([val]).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data
          }
        })
      },
      // 编辑场站选中时
      stationSelect(val) {
        commonApi.pilesForSelect(val).then((res) => {
          if (res.code === 0) {
            this.pilesForSelect = res.data
          }
        })
      },
      // 编辑设备选中时
      pileSelect(val) {
        pileApi.getPileTypeById(val).then((res) =>{
          if (res.code === 0){
            console.log(res.data.gunCount)
            this.maxGunNum = res.data.gunCount
          }
        })
        for (let i = 0; i < this.pilesForSelect.length; i++) {
          if (this.pilesForSelect[i].id === val) {
            this.editForm.pileCode = this.pilesForSelect[i].pileCode
          }
        }
      },
      startGunNumCheck(rule, value, callback) {
        let self = this
        setTimeout(() => {
          if (value>=self.editForm.endGunNum){
            callback(new Error(this.$t('qi-shi-qiang-hao-bu-neng-da-yu-jie-shu-qiang-hao')));
          }
          callback();
        }, 100);
      },
      endGunNumCheck(rule, value, callback) {
        let self = this
        setTimeout(() => {
          if (value>self.maxGunNum){
            callback(new Error(this.$t('jie-shu-qiang-hao-bu-neng-da-yu-xing-hao-xian-zhi-qiang-kou-shu-liang')+self.maxGunNum));
          }
          callback();
        }, 100);
      },
      exportCode(type) {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.exportLoading = true
          let param = this.searchForm;
          this.$set(param,'type',type)
          gunApi.exportCode(this.searchForm).then(res => {
            const blob = new Blob([res],{
              type: 'application/octet-stream;charset=utf-8'
            })
            const fileName = 'qrcode.zip'
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a')
              elink.download = fileName
              elink.style.display = 'none'
              elink.href = window.URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              window.URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, fileName)
            }
          }).finally(() => {
            this.exportLoading = false
          })
        })
      },
      exportQRCodeSubmit(type){
        this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
          this.exportLoading = true;
          let param = this.searchForm;
          this.$set(param,'type',type)
          this.$set(param,'url',this.exportQRCodeForm.url)
          gunApi.exportCode(this.searchForm).then(res => {
            const blob = new Blob([res],{
              type: 'application/octet-stream;charset=utf-8'
            })
            const fileName = 'qrcode.zip'
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a')
              elink.download = fileName
              elink.style.display = 'none'
              elink.href = window.URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              window.URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, fileName)
            }
          }).finally(() => {
            this.exportLoading = false
          })
        })
      }
    },
    components: {
      Pagination,
      search,
      list,
      add,
      detail
    },
    created: function () {
      this.loadSelectItem()
      this.loadForSelect()
    },
    mounted: function () {
      this.submitSearchForm()
    },
    watch:{
      'editForm.gunNum'(gunNum){
        this.editGunNum(gunNum)
      },
      'editForm.startGunNum'(startGunNum){
        this.editStartGunNum(startGunNum)
      },
      'editForm.endGunNum'(endGunNum){
        this.editEndGunNum(endGunNum)
      }
    },
    computed: {},
  }
</script>

<style lang="less" scoped>
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }

  .el-btn {
    /*float: right;*/
    margin-bottom: 15px;
  }

  /deep/ .search_form {
    .el-form-item__content {
      .el-input {
        width: auto;
      }
    }
  }

  /deep/.el-dialog{
    width: 900px;
  }

  /deep/ .edit_form, /deep/ .detail_form {
    height: 600px;
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }
  /deep/ .diy-class {
    .el-form-item__content {
      line-height: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/charginggunManager.vue